import { useEffect, useState } from "react";
import Modal from "../../../Components/Modal/Modal";
import SmallCard from "../../../Components/SmallCard/SmallCard";
import checkEmpty from "../../../images/Check_Empty.svg"
import check from "../../../images/Check.svg"
import ccpa from "crypto-pro-cadesplugin";
import useFileService from "../../../Services/FileService";
import avatar from "../../../images/Avatar_2.svg"

export default function SignatureModal({ documents, setDocuments, isOpen, setOpen, addSignature, participant, request, setRequest }) {
    const [certs, setCerts] = useState([])

    const { downloadFile } = useFileService()
    const getCertsList = async () => {
        const certsList = await ccpa().then(x => x.getCertsList());
        return certsList;
    }
    useEffect(() => {

        getCertsList().then(x => {
            const newState = x.map((cert) => {
                const subject = cert.friendlySubjectInfo()[0].text;
                const valid = cert.friendlyValidPeriod().to.ddmmyy;
                return { ...cert, subject: subject, valid: valid }
            })
            setCerts(newState)
        })
    }, [])

    const selectDocument = (documentId) => {
        const newState = documents.map((document) => {
            if (document.Id === documentId) {
                return { ...document, isActive: !document.isActive }
            }
            return document;
        })
        setDocuments(newState)
    }
    const selectCertificate = (thumbprint) => {
        const newState = certs.map((cert) => {
            if (cert.thumbprint === thumbprint) {
                return { ...cert, isActive: true }
            }
            return { ...cert, isActive: false };
        })
        setCerts(newState)
    }
    const onSave = () => {
        const cert = certs.find(x => x.isActive)
        documents.filter(x => x.isActive).forEach(doc => {
            downloadFile(doc.FileUuid).then(async (base64) => {

                const signed = await ccpa().then(x => {
                    return x.signBase64(cert.thumbprint, base64)
                })
                addSignature(doc.Id, participant.Id, null, signed, 2).then(x => {

                    const newParticipant = participant;
                    newParticipant.Documents = newParticipant.Documents.map((x) => {
                        if (x.Id === doc.Id) {
                            return { ...x, Status: { ...x.Status, code: 3 } }
                        }
                        return x
                    })
                    const newState = request;
                    newState.Participants = newState.Participants.map((x) => {
                        if (x.Id === newParticipant.Id) {
                            return newParticipant
                        }
                        return x
                    })
                    setRequest(newState)
                })
            }
            )
        });
    }
    const title = `${participant?.FlSubject == null ? participant?.UlAgent?.name : participant?.FlSubject?.name} `
    return (<Modal onSave={onSave} title={`Подписание документов`} isOpen={isOpen} setOpen={setOpen}>
        <label>Подписант</label>
        <SmallCard title={title} avatar={avatar}></SmallCard>
        <label>Выберите документы на подпись</label>

        {documents.map((x) =>

            <SmallCard title={x.FileName} onSelect={() => selectDocument(x.Id)} type={x.isActive ? "primary" : "default"} avatar={x.isActive ? check : checkEmpty} subtitle={`Тип документа: ${x.DocType.name}`}></SmallCard>
        )}
        <label>Выберите подпись</label>
        {certs.map((x) =>
            <SmallCard avatar={x.isActive ? check : checkEmpty} type={x.isActive ? "primary" : "default"} onSelect={() => selectCertificate(x.thumbprint)} title={x.subject} subtitle={`Действует до ${x.valid}`}></SmallCard>
        )}
    </Modal>)
}